import x from "../../node_modules/classnames/index.js";
import { forwardRef as l } from "react";
import "./UIInputText2.js";
import { jsx as n } from "../../_virtual/jsx-runtime.js";
const I = l(({
  hasError: m,
  name: r,
  className: p,
  disabled: t,
  onBlur: i,
  onChange: o,
  placeholder: a,
  value: u,
  variant: e = "medium"
}, s) => /* @__PURE__ */ n("input", {
  ref: s,
  type: "text",
  "data-error": m,
  disabled: t,
  placeholder: a,
  className: x("input-text", "shakeable", {
    "input-text--disabled": t,
    "input-text--large": e === "large",
    "input-text--medium": e === "medium"
  }, p),
  name: r,
  value: u || "",
  onBlur: i,
  onChange: o
}));
export {
  I as UIInputText
};
//# sourceMappingURL=UIInputText.js.map
